import Listy from "./List";
export default Listy;